<template>
  <q-page class="main">
    <common-form ref="form" :action="$route('project.category.update', {project_id: project.id})" is-update>
      <q-card class="page-card">
        <q-card-section class="page-card__main-content">
          <h1 class="heading-2 q-mb-lg">Relevante categorieën</h1>
          <item-selection
              v-model="form.category_ids"
              label="Relevante categorie&euml;n"
              :rows="2"
              :items="categories"
              name="category_ids[]" />
        </q-card-section>
        <q-separator />
        <q-card-actions align="right" class="q-pa-md">
          <accent-button label="Opslaan" @click="onCategoriesSubmit()" />
        </q-card-actions>
      </q-card>
      <sticky-top-bar />
    </common-form>
  </q-page>
</template>

<script>
import ItemSelection from '../../../components/form/ItemSelection'
export default {
  components: { ItemSelection },
  props: {
    project: {
      type: Object,
      required: false
    },
    categories: {
      type: Array,
      default: () => []
    },
    categoryIds: {
      type: Array,
      default: () => []
    },
  },
  data() {
    return {
      form: {
        category_ids: [...this.categoryIds]
      }
    }
  },
  computed: {
    //TODO kan category ids ook uit project.categories worden gehaald als een computed prop?
    // ipv meegeven uit de controller
    optionsArray() {
      return this.categories.map((category) => {
        return {
          value: category.id,
          label: category.title,
        }
      })
    }
  },
  methods: {
    async onCategoriesSubmit() {
      if (!await this.$confirm(
          {
            title: 'Categorieën opslaan',
            messages: [
              'Het aanpassen van de categorieën die van toepassing zijn op dit ' +
              'project zal de koppeling tussen richtlijnen en dit project veranderen. Weet u zeker dat u dit ' +
              'formulier wilt opslaan?'
            ]
          }
      )) {
        return
      }

      this.$refs.form.$el.submit()
    }
  }
}
</script>
